/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-useless-constructor */
import BaseObserver from './baseObserver';

export default class SmartArtModelObserver extends BaseObserver {
    /**
     * @param isModelRenderer 是否是渲染元素。
     * @returns
     */
    getObserveData(isModelRenderer?: boolean): Record<string, any> {
        return {
            // 渲染组合时，无需监听选中组合，仅selected-group-wrapper需要监听
            selected: isModelRenderer ? undefined : this.model.selected,
            operationFrame: this.model.operationFrame,
            previewChange: this.model.previewChange,
            // 子元素的更新可能会触发组合的刷新
            refreshGroupByChildrenWithoutChangeSet: isModelRenderer
                ? this.model.refreshGroupByChildrenWithoutChangeSet
                : undefined,
        } ;
    }
}
